<template>
	<teleport to="#app">
		<BaseDialog :isOpen="isVisible" @close="close" :isSearch="isSearch">
			<template #default>
				<Transition
					enter-active-class="transition-opacity duration-300 ease-out"
					enter-from-class="opacity-0"
					enter-to-class="opacity-100"
					leave-active-class="transition-opacity duration-200 ease-in"
					leave-from-class="opacity-100"
					leave-to-class="opacity-0"
				>
					<div
						class="fixed inset-0 z-50 flex items-start justify-center pt-20 px-4 bg-black/20 backdrop-blur-sm"
						@click="handleBackdropClick"
					>
						<Transition
							enter-active-class="transition-all duration-400 ease-out"
							enter-from-class="opacity-0 scale-95 translate-y-8"
							enter-to-class="opacity-100 scale-100 translate-y-0"
							leave-active-class="transition-all duration-250 ease-in"
							leave-from-class="opacity-100 scale-100 translate-y-0"
							leave-to-class="opacity-0 scale-95 translate-y-4"
							appear
						>
							<div
								class="w-full max-w-2xl bg-white rounded-2xl shadow-2xl overflow-hidden border border-gray-200/50 transform-gpu"
								@click.stop
							>
								<Transition
									enter-active-class="transition-all duration-500 ease-out delay-100"
									enter-from-class="opacity-0 translate-y-[-10px]"
									enter-to-class="opacity-100 translate-y-0"
									appear
								>
									<div class="border-b border-gray-100">
										<SearchBar @close="close" @termChange="onTermChange" />
									</div>
								</Transition>

								<Transition
									enter-active-class="transition-all duration-500 ease-out delay-200"
									enter-from-class="opacity-0 translate-y-[15px]"
									enter-to-class="opacity-100 translate-y-0"
									appear
								>
									<div class="max-h-96 overflow-y-auto">
										<Transition
											mode="out-in"
											enter-active-class="transition-all duration-300 ease-out"
											enter-from-class="opacity-0 translate-y-4"
											enter-to-class="opacity-100 translate-y-0"
											leave-active-class="transition-all duration-200 ease-in"
											leave-from-class="opacity-100 translate-y-0"
											leave-to-class="opacity-0 translate-y-[-4px]"
										>
											<div
												v-if="isLoading"
												key="loading"
												class="flex items-center justify-center py-12"
											>
												<div
													class="w-6 h-6 border-2 border-gray-300 border-t-blue-500 rounded-full animate-spin"
												></div>
											</div>

											<div
												v-else-if="error"
												key="error"
												class="flex items-center justify-center py-12 text-gray-500"
											>
												{{ error }}
											</div>

											<div
												v-else-if="local_hotspots.length > 0"
												key="results"
												class="py-2"
											>
												<TransitionGroup
													enter-active-class="transition-all duration-400 ease-out"
													enter-from-class="opacity-0 translate-x-[-20px]"
													enter-to-class="opacity-100 translate-x-0"
													leave-active-class="transition-all duration-200 ease-in"
													leave-from-class="opacity-100 translate-x-0"
													leave-to-class="opacity-0 translate-x-[20px]"
													tag="div"
												>
													<div
														v-for="(hotspot, index) in local_hotspots"
														:key="hotspot.id || hotspot.slug"
														@click="openHotspot(hotspot)"
														class="flex items-center justify-between px-6 py-3 cursor-pointer hover:bg-gray-50 transition-all duration-200 group hover:scale-[1.01] active:scale-[0.99]"
														:style="{ transitionDelay: index * 75 + 'ms' }"
													>
														<div class="flex-1 min-w-0">
															<div
																class="text-gray-900 font-medium text-base truncate transition-colors duration-200 group-hover:text-gray-700"
															>
																{{ decodeHtml(hotspot.title) }}
																<span
																	class="text-gray-500 font-normal ml-2 transition-colors duration-200 group-hover:text-gray-600"
																>
																	({{
																		getTranslations(
																			(typeof hotspot.layer === 'string' ? hotspot.layer : (hotspot.layer?.title || hotspot.layer?.slug || hotspot.layer || ''))
																				.replace(/-/g, " ")
																				.replace(/&nbsp;/g, " ")
																		)
																	}})
																</span>
															</div>
														</div>
														<ArrowRightIcon
															class="w-4 h-4 text-gray-400 group-hover:text-blue-500 transition-all duration-200 flex-shrink-0 ml-3 group-hover:translate-x-1"
														/>
													</div>
												</TransitionGroup>
											</div>

											<div
												v-else
												key="empty"
												class="flex items-center justify-center py-12 text-gray-500"
											>
												{{ getTranslations("Start typing to search...") }}
											</div>
										</Transition>
									</div>
								</Transition>
							</div>
						</Transition>
					</div>
				</Transition>
			</template>
		</BaseDialog>
	</teleport>
</template>
<script src="./SearchModal.js" lang="js"></script>
